var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "topnav-section-container" }, [
    _c("div", { staticClass: "left-section" }, [
      _vm.customComponentsUrl && _vm.customComponentMarkup
        ? _c(
            "div",
            {
              staticClass: "custom-components",
              class: {
                "include-navigation":
                  _vm.showNavigation && _vm.localNavigation.length > 0
              }
            },
            [
              _vm._t("custom-components", [
                _c("NsDynamicHtml", {
                  attrs: { template: _vm.customComponentMarkup }
                })
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNavigation
        ? _c(
            "div",
            { staticClass: "navigation" },
            [
              _vm._t("navigation", [
                _c("NsTopnavNavigation", {
                  attrs: {
                    navigation: _vm.localNavigation,
                    "nav-type": _vm.navType,
                    "hide-see-all": _vm.hideSeeAll
                  }
                })
              ])
            ],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "nav-image" },
      [
        _vm.showImageOverlay
          ? _c("NsTopnavImageOverlay", {
              attrs: {
                src: _vm.navImage.src,
                "overlay-text": _vm.navImage.overlayText,
                alt: _vm.navImage.alt
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }